import { useState, useCallback } from 'react';
import { ValidationTabsEnum } from "../../../../types/validation";
import useLegendStore from "../../../../store/legendStore";
import {
  EVENT_VALIDATION_INSITU_SELECTED,
  EVENT_VALIDATION_SATELLITE_SELECTED,
  trackUpdate
} from "../../../../utils/matomoEvents";
import { DEFAULT_ANALYTICS } from "../../../../types/analytics";
import { IMarker } from "../../../../types/marker";

export function useValidationTabs(activePoint?: IMarker, datasetId?: string) {
  const [activeValidationTab, setActiveValidationTab] = useState<ValidationTabsEnum>(ValidationTabsEnum.SATELLITE_TAB);
  const setShowInSituPoints = useLegendStore(state => state.setShowInSituPoints);

  const handleChangeTab = useCallback((key: ValidationTabsEnum) => {
    if (activePoint?.coordinates?.length && datasetId) {
      const eventType = key === ValidationTabsEnum.INSITU_TAB ? EVENT_VALIDATION_INSITU_SELECTED : EVENT_VALIDATION_SATELLITE_SELECTED;
      trackUpdate(eventType, activePoint.coordinates, datasetId, key === ValidationTabsEnum.INSITU_TAB ? DEFAULT_ANALYTICS : "");
    }
    if (key === ValidationTabsEnum.INSITU_TAB) {
      setShowInSituPoints(true);
    }
    setActiveValidationTab(key);
  }, [activePoint?.coordinates, datasetId, setShowInSituPoints]);

  return { activeValidationTab, setActiveValidationTab, handleChangeTab };
}
